// src/components/WidgetLoader.jsx
import { useEffect, useState, useRef } from 'react';

export default function WidgetLoader({ agentId }) {
  // check for driver_id in the local storage after login has happened and then set the widget, otherwise keep checking every 1 seconds until it exists don't return the widget until the driver_id is found.
  const [driverId, setDriverId] = useState(null);
  const [sessionId, setSessionId] = useState(null);
  const widgetRef = useRef(null);

  useEffect(() => {
    let intervalId;
    const checkDriverId = () => {
      const storedDriverId = localStorage.getItem('driverId');
      const storedSessionId = localStorage.getItem('sessionId');
      if (storedDriverId && storedSessionId) {
        setDriverId(storedDriverId);
        setSessionId(storedSessionId);
        clearInterval(intervalId);
      }
    };
    checkDriverId(); // Initial check
    if (!driverId) {
      intervalId = setInterval(checkDriverId, 1000);
    }
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    if (!driverId) return;

    // Only create widget if it doesn't exist
    if (!widgetRef.current) {
      // Only define it once
      if (!customElements.get('elevenlabs-convai')) {
        // 1) add the widget tag
        const widget = document.createElement('elevenlabs-convai');
        widget.setAttribute('agent-id', agentId);
        widget.setAttribute('dynamic-variables', JSON.stringify({ driver_id: driverId, session_id: sessionId }));
        //widget.setAttribute('variant', 'expanded');
        document.body.appendChild(widget);
        widgetRef.current = widget;

        // 2) load their script once
        const s = document.createElement('script');
        s.src = 'https://elevenlabs.io/convai-widget/index.js';
        s.async = true;
        document.body.appendChild(s);
      }
    } else {
      // Update existing widget's driver_id if it changed
      widgetRef.current.setAttribute('dynamic-variables', JSON.stringify({ driver_id: driverId, session_id: sessionId }));
    }

    // Only clean up when component is actually unmounted
    return () => {
      // Don't remove widget on route changes, only on actual unmount
      if (widgetRef.current && !document.body.contains(widgetRef.current)) {
        widgetRef.current.remove();
        widgetRef.current = null;
      }
    };
  }, [agentId, driverId]);

  return null;
}
